const isInRole = (roles = [], roleName) => {
    return (
        roles.findIndex(
            (item) => item.name.toLowerCase() === roleName.toLowerCase(),
        ) > -1
    );
};

export default isInRole;
